module.exports = __webpack_public_path__ + "img/Dong_Yu@2x.af6cc611.png";